/* FocusPod 1.1.0: passive, staged journey adapter. No network, cart writes or form submission. */
(function(w,d){
  'use strict';
  if(w.FocusPodMeasurementJourney)return;
  var labels={solo:'Solo','solo-plus':'Solo Plus',duo:'Duo',team:'Team',meet:'Meet',max:'Max'};
  var pending=new WeakSet();
  var metrics={committed_designs:0,failed_or_unchanged:0,adapter_errors:0};
  function api(){return w.FocusPodMeasurement;}
  function start(){if(api())api().startConfigurator();}
  function safeSelection(s){
    if(!s||!Object.prototype.hasOwnProperty.call(labels,s.model)||!Number.isSafeInteger(s.quantity)||s.quantity<1||s.quantity>100)return null;
    // Only allow machine codes. Never copy custom finishes, customer data or free-text summaries.
    function code(v){return typeof v==='string'&&/^[a-z0-9_-]{1,40}$/i.test(v)?v:'';}
    return {model:s.model,quantity:s.quantity,furniture:code(s.furniture),installation:s.installation===true,exterior:code(s.exterior),interior:code(s.interior),extras:Array.isArray(s.extras)?s.extras.slice(0,10).map(code).filter(Boolean).sort():[]};
  }
  function snapshot(root){
    var builder=w.FocusPodRegionalBuilder;
    if(!builder||typeof builder.snapshot!=='function'||root.getAttribute('aria-busy')!=='false')return null;
    var s=builder.snapshot(),ctx=api().context();
    if(!s||s.country!==ctx.content_market||!Array.isArray(s.designs)||s.designs.length>20||!['USD','AUD','NZD','GBP','AED','ZAR'].includes(s.currency))return null;
    var designs=s.designs.map(safeSelection),state=safeSelection(s.state);
    if(designs.some(function(x){return !x;})||!state||designs.reduce(function(n,x){return n+x.quantity;},0)>100)return null;
    return {country:s.country,currency:s.currency,designs:designs,state:state};
  }
  function signature(s){return JSON.stringify(s);}
  function committed(root,before){
    try{
      var a=api();if(!a)return;
      var after=snapshot(root);
      if(!after||before.country!==after.country||before.currency!==after.currency||after.designs.length<before.designs.length||after.designs.length>before.designs.length+1){metrics.failed_or_unchanged++;return;}
      var added=after.designs.length===before.designs.length+1,changed=[];
      if(added){
        if(signature(before.designs)!==signature(after.designs.slice(0,-1))){metrics.failed_or_unchanged++;return;}
        changed=[after.designs[after.designs.length-1]];
      }else{
        after.designs.forEach(function(s,i){if(signature(s)!==signature(before.designs[i]))changed.push(s);});
      }
      if(changed.length!==1||signature(changed[0])!==signature(before.state)){metrics.failed_or_unchanged++;return;}
      var selection=changed[0],id;try{id=w.crypto.randomUUID();}catch(_){return;}
      var payload={event_id:id,product_model:labels[selection.model],quantity:selection.quantity,placement:'configurator',price_basis:'planning'};
      // Read verified committed pricing only. Its currency is never inferred from Shopify's cart.
      try{
        var raw=w.FocusPodRegionalBuilder.snapshot(),index=added?raw.designs.length-1:after.designs.findIndex(function(s,i){return signature(s)!==signature(before.designs[i]);});
        var result=w.FocusPodRegionalBuilder.calculate(raw.designs[index]);
        if(result&&Number.isSafeInteger(result.subtotalCents)&&result.subtotalCents>=0&&result.subtotalCents<=100000000000){payload.quote_value=result.subtotalCents/100;payload.currency=after.currency;}
      }catch(_){}
      if(a.track('configuration_complete',payload)){metrics.committed_designs++;if(added)a.track('add_to_quote',payload);}
    }catch(_){metrics.adapter_errors++;}
  }
  // Capture the old state, then wait for the existing builder to accept (or reject) its action.
  d.addEventListener('click',function(event){
    try{
      var target=event.target&&event.target.closest?event.target:null;if(!target||!api())return;
      var root=target.closest('.us-configurator[data-fp-builder]');
      if(!root)return;
      var control=target.closest('button,input,select,[role="radio"],[role="button"]');
      if(!control||control.disabled||control.getAttribute('aria-disabled')==='true')return;
      if(control.id==='builder-email'||control.id==='builder-order-review')return;
      start();
      if(control.id!=='builder-add'||pending.has(control))return;
      var before=snapshot(root);if(!before)return;
      pending.add(control);
      w.setTimeout(function(){pending.delete(control);committed(root,before);},0);
    }catch(_){metrics.adapter_errors++;}
  },true);
  // The existing Australian quote overlay remains owned by its original tracking script.
  w.FocusPodMeasurementJourney=Object.freeze({version:'1.1.0-staged',diagnostics:function(){return {mode:'staging',metrics:JSON.parse(JSON.stringify(metrics)),google_delivery_enabled:false};}});
})(window,document);
